// import React, { useState, useEffect } from "react";
// import { Layout, Menu, Dropdown, Drawer, Button } from "antd";
// import { MenuOutlined, DownOutlined, PhoneOutlined } from "@ant-design/icons";
// import { Link, NavLink } from "react-router-dom";
// import Logo from "../../src/Assets/Logo.png";

// import "./AppHeader.css";

// const { Header } = Layout;

// const AppHeader = () => {
//   const [mobile, setMobile] = useState(window.innerWidth < 900);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   useEffect(() => {
//     const resize = () => setMobile(window.innerWidth < 900);
//     window.addEventListener("resize", resize);
//     return () => window.removeEventListener("resize", resize);
//   }, []);

//   return (
//     <>
//       <Header
//         style={{
//           position: "fixed",
//           top: 0,
//           width: "100%",
//           zIndex: 1000,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: 24,
//           background: "linear-gradient(to right, #FFD700, #FFA500)",
//         }}
//       >
//         <div
//           style={{
//             fontWeight: "bold",
//             fontSize: 20,
//             color: "#000",
//             whiteSpace: "nowrap",
//           }}
//         >
//            <Link to="/">
//           <img
//             src={Logo}
//             alt="Yoga Refer.com"
//             style={{
//               height: mobile ? "45px" : "60px",
//               width: "auto",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </Link>
//         </div>

//         {/* DESKTOP MENU */}
//         {!mobile && (
//           <div style={{ display: "flex", gap: 24 }}>
//             <NavLink
//               to="/"
//               className={({ isActive }) =>
//                 isActive ? "nav-item nav-active" : "nav-item"
//               }
//               style={{ color: "#000" }}
//             >
//               Home
//             </NavLink>

//             {/* Yoga & Practice */}
//             <div className="nav-dropdown">
//               <span className="nav-item">
//                 Yoga & practice <DownOutlined />
//               </span>
//               <div className="nav-dropdown-menu">
//                 <Link to="/yoga">Yoga</Link>
//                 <Link to="/alternate-asana">Alternate Asana</Link>
//                 <Link to="/how-to-make-variation">How to make variation</Link>
//                 <Link to="/warm-up">Warm-up</Link>
//               </div>
//             </div>

//             {/* Breathing */}
//             <div className="nav-dropdown">
//               <span className="nav-item">
//                 Breathing & cleaning <DownOutlined />
//               </span>
//               <div className="nav-dropdown-menu">
//                 <Link to="/breathe-technique">Breathing Technique</Link>
//                 <Link to="/shatkarmas">Cleaning (Shatkarmas)</Link>
//               </div>
//             </div>

//             {/* Meditation */}
//             <div className="nav-dropdown">
//               <span className="nav-item">
//                 Mind & meditation <DownOutlined />
//               </span>
//               <div className="nav-dropdown-menu">
//                 <Link to="/meditation">Meditation</Link>
//                 <Link to="/chakra">Chakra</Link>
//                 <Link to="/mudra">Mudra</Link>
//               </div>
//             </div>

//             {/* Guide */}
//             <div className="nav-dropdown">
//               <span className="nav-item">
//                 Yoga guide & tips <DownOutlined />
//               </span>
//               <div className="nav-dropdown-menu">
//                 <Link to="/dos-and-donts">Dos & Don’ts</Link>
//                 <Link to="/tool">Tools</Link>
//                 <Link to="/dictionary">Dictionary</Link>
//                 <Link to="/time">Time</Link>
//               </div>
//             </div>

//             <a href="tel:+91 996296 10424" style={{ color: "#000", display: "flex", alignItems: "center", gap: 6 }}>
//   <PhoneOutlined style={{ fontSize: 18 }} />
  
// </a>
//           </div>
//         )}

//         {/* MOBILE MENU BUTTON */}
//         {mobile && (
//           <Button icon={<MenuOutlined />} onClick={() => setDrawerOpen(true)} />
//         )}
//       </Header>

//       {/* MOBILE DRAWER */}
//       <Drawer
//         placement="right"
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         closable={false}
//         bodyStyle={{ padding: 0 }}
//       >
//         <div className="drawer-header">
//           <span className="close-icon" onClick={() => setDrawerOpen(false)}>
//             ✕
//           </span>
//           <span className="menu-title">Menu</span>
//         </div>

//         <Menu mode="inline" className="mobile-menu" onClick={() => setDrawerOpen(false)}>
//           <Menu.Item>
//             <Link to="/">Home</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/yoga">Yoga</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/alternate-asana">Alternate Asana</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/how-to-make-variation">How to make variation</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/warm-up">Warm-up</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/breathe-technique">Breathe Technique</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/shatkarmas">Shatkarmas</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/meditation">Meditation</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/chakra">Chakra</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/mudra">Mudra</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/dos-and-donts">Dos & Don’ts</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/time">Time</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/dictionary">Dictionary</Link>
//           </Menu.Item>

//           <Menu.Item>
//             <Link to="/tool">Tools</Link>
//           </Menu.Item>
//         </Menu>
//       </Drawer>
//     </>
//   );
// };

// export default AppHeader;

import React, { useState, useEffect } from "react";
import { Layout, Menu, Drawer, Button } from "antd";
import { Link, useLocation } from "react-router-dom";
import { PhoneOutlined, MenuOutlined, DownOutlined } from "@ant-design/icons";
import { AnimatePresence, motion } from "framer-motion";
import Logo from "../../src/Assets/Logo.png";

const { Header } = Layout;

const yogaMenuItems = [
  { key: "/yoga", label: "Yoga", path: "/yoga" },
  { key: "/alternate-asana", label: "Alternate Asana", path: "/alternate-asana" },
  { key: "/how-to-make-variation", label: "How to make variation", path: "/how-to-make-variation" },
  { key: "/warm-up", label: "Warm-up", path: "/warm-up" },
];

const breathingMenuItems = [
  { key: "/breathe-technique", label: "Breathe Technique", path: "/breathe-technique" },
  { key: "/shatkarmas", label: "Shatkarmas", path: "/shatkarmas" },
];

const mindMenuItems = [
  { key: "/meditation", label: "Meditation", path: "/meditation" },
  { key: "/chakra", label: "Chakra", path: "/chakra" },
  { key: "/mudra", label: "Mudra", path: "/mudra" },
];

const guideMenuItems = [
  { key: "/dos-and-donts", label: "Dos & Don'ts", path: "/dos-and-donts" },
  { key: "/time", label: "Best time for yoga", path: "/time" },
  { key: "/dictionary", label: "Yoga Dictionary", path: "/dictionary" },
  { key: "/tool", label: "Yoga Tools", path: "/tool" },
];

const mobileMenuItems = [
  { key: "/", label: <Link to="/">Home</Link> },
  { key: "/yoga", label: <Link to="/yoga">Asanas</Link> },
  { key: "/alternate-asana", label: <Link to="/alternate-asana">Alternate Asana</Link> },
  { key: "/how-to-make-variation", label: <Link to="/how-to-make-variation">How to make variation</Link> },
  { key: "/warm-up", label: <Link to="/warm-up">Warm-up</Link> },
  { key: "/breathe-technique", label: <Link to="/breathe-technique">Breathe Technique</Link> },
  { key: "/shatkarmas", label: <Link to="/shatkarmas">Shatkarmas</Link> },
  { key: "/meditation", label: <Link to="/meditation">Meditation</Link> },
  { key: "/chakra", label: <Link to="/chakra">Chakra</Link> },
  { key: "/mudra", label: <Link to="/mudra">Mudra</Link> },
  { key: "/dos-and-donts", label: <Link to="/dos-and-donts">Dos & Don'ts</Link> },
  { key: "/time", label: <Link to="/time">Time</Link> },
  { key: "/dictionary", label: <Link to="/dictionary">Dictionary</Link> },
  { key: "/tool", label: <Link to="/tool">Tools</Link> },
];


const FlyoutLink = ({ children, FlyoutContent, isActive }) => {
  const [open, setOpen] = useState(false);
  const showFlyout = FlyoutContent && open;

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{
        position: "relative",
        height: "64px",
        display: "flex",
        alignItems: "center",
        padding: "0 24px",
        cursor: "pointer",
        borderRadius: "4px",
        backgroundColor: isActive ? "#FFD700" : "transparent",
        color: isActive ? "#26365C" : "#000000",
        fontWeight: 500,
        transition: "all 0.3s ease",
      }}
      className="flyout-link-hover"
    >
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {children}
        <DownOutlined style={{ fontSize: 12 }} />
      </span>
      
      <motion.span
        style={{
          position: "absolute",
          bottom: 0,
          left: "8px",
          right: "8px",
          height: "3px",
          backgroundColor: "#FFD700",
          borderRadius: "2px",
          transformOrigin: "left",
        }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: showFlyout ? 1 : 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      />

      <AnimatePresence>
        {showFlyout && (
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 15 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            style={{
              position: "absolute",
              left: 0,
              top: "64px",
              zIndex: 1001,
            }}
          >
            {/* Invisible spacer to keep dropdown open when moving mouse */}
            <div style={{ position: "absolute", top: "-8px", left: 0, right: 0, height: "8px", background: "transparent" }} />
            
            {/* Arrow pointer */}
            <div
              style={{
                position: "absolute",
                left: "20px",
                top: 0,
                width: "16px",
                height: "16px",
                transform: "translateY(-50%) rotate(45deg)",
                backgroundColor: "#ffffff",
                boxShadow: "-2px -2px 4px rgba(0,0,0,0.1)",
              }}
            />
            
            <FlyoutContent />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};


const DropdownContent = ({ items }) => {
  return (
    <div
      style={{
        minWidth: "220px",
        backgroundColor: "#ffffff",
        padding: "12px 0",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        borderRadius: "8px",
      }}
    >
      {items.map((item) => (
        <Link
          key={item.key}
          to={item.path}
          style={{
            display: "block",
            padding: "10px 20px",
            color: "#26365C",
            textDecoration: "none",
            fontWeight: 500,
            transition: "all 0.2s ease",
          }}
          className="dropdown-item-hover"
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

const AppHeader = () => {
  const [mobile, setMobile] = useState(window.innerWidth < 900);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 900);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const goldMenuStyles = `
    .gold-menu {
      background: transparent !important; 
      border-bottom: none !important;
      line-height: 64px;
    }

    .gold-menu .ant-menu-item {
      color: black !important; 
      font-weight: 500;
      margin: 0 4px;
      transition: all 0.3s ease;
      height: 64px;
      line-height: 64px;
      border-radius: 4px; 
      padding: 0 10px;
      border-bottom: none !important;
    }

    .gold-menu .ant-menu-item a {
      color: inherit !important;
    }

    .gold-menu .ant-menu-item:not(.ant-menu-item-selected):hover {
      background-color: #000000 !important; 
      color: #FFD700 !important;            
    }
    
    .gold-menu .ant-menu-item:not(.ant-menu-item-selected):hover a {
      color: #eceae3ff !important;          
    }

    .gold-menu .ant-menu-item-selected {
      background-color: #FFD700 !important; 
      color: #26365C !important; 
      border-bottom: none !important;
    }

    .gold-menu .ant-menu-item-selected a {
      color: #26365C !important;
    }
    
    .ant-drawer-body .gold-menu .ant-menu-item {
      color: #26365C !important;
      line-height: 48px;
      height: 48px;
    }

    .ant-drawer-body .gold-menu .ant-menu-item:hover {
      background-color: #000000 !important;
      color: #ffffff !important;
    }

    /* Flyout Link Hover */
    .flyout-link-hover:hover {
      background-color: #000000 !important;
      color: #FFD700 !important;
    }

    /* Dropdown Item Hover */
    .dropdown-item-hover:hover {
      background-color: #000000 !important;
      color: #FFD700 !important;
    }
  `;

  return (
    <>
      <style>{goldMenuStyles}</style>

      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: mobile ? "0 10px" : "0 20px",
          gap: 10,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 1000,
         background: "linear-gradient(to right, #ffffff 40%, #FFD700 100%)",
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          overflowX: "visible",
          overflowY: "visible",
        }}
      >
        {/* LOGO */}
        <Link to="/">
          <img
            src={Logo}
            alt="Yoga Refer.com"
            style={{
              height: mobile ? "45px" : "65px",
              width: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Link>

        {/* DESKTOP MENU */}
        {!mobile && (
          <div style={{ display: "flex", alignItems: "center", height: "64px", gap: "24px" }}>
            {/* Home Link */}
            <Link
              to="/"
              style={{
                height: "64px",
                display: "flex",
                alignItems: "center",
                padding: "0 24px",
                borderRadius: "4px",
                backgroundColor: location.pathname === "/" ? "#FFD700" : "transparent",
                color: location.pathname === "/" ? "#26365C" : "#000000",
                fontWeight: 500,
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
              className="flyout-link-hover"
            >
              Home
            </Link>

            {/* Yoga Dropdown */}
            <FlyoutLink
              FlyoutContent={() => <DropdownContent items={yogaMenuItems} />}
              isActive={yogaMenuItems.some(item => item.path === location.pathname)}
            >
              Yoga & practice 
            </FlyoutLink>

            {/* Cleaning Dropdown */}
            <FlyoutLink
              FlyoutContent={() => <DropdownContent items={breathingMenuItems} />}
              isActive={breathingMenuItems.some(item => item.path === location.pathname)}
            >
              Breathing & cleaning 
            </FlyoutLink>

            {/* Mind Dropdown */}
            <FlyoutLink
              FlyoutContent={() => <DropdownContent items={mindMenuItems} />}
              isActive={mindMenuItems.some(item => item.path === location.pathname)}
            >
              Mind & meditation 
            </FlyoutLink>

            {/* Guide Dropdown */}
            <FlyoutLink
              FlyoutContent={() => <DropdownContent items={guideMenuItems} />}
              isActive={guideMenuItems.some(item => item.path === location.pathname)}
            >
             Yoga guide & tips
            </FlyoutLink>

            {/* Phone Icon */}
            <a
              href="https://admin.yogarefer.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    height: "64px",
    display: "flex",
    alignItems: "center",
    padding: "0 24px",
    borderRadius: "4px",
    color: "#000000",
    fontWeight: 500,
    textDecoration: "none",
    transition: "all 0.3s ease",
  }}
  className="flyout-link-hover"
>
  Send Contribution
</a>
          </div>
        )}

        {/* MOBILE MENU BUTTON */}
        {mobile && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {/* PHONE ICON */}
            <a
              href="https://admin.yogarefer.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 10px",
        height: 36,
        borderRadius: 6,
        background: "#ffffff",
        color: "#26365C",
        fontWeight: 500,
        fontSize: 13,
        textDecoration: "none",
        boxShadow: "0 1px 3px rgba(0,0,0,0.4)",
      }}
    >
      Send Contribution
    </a>

            {/* MENU BUTTON */}
            <Button
              type="primary"
              icon={<MenuOutlined style={{ fontSize: 18 }} />}
              onClick={() => setDrawerOpen(true)}
              style={{
                padding: "4px 8px",
                background: "white",
                borderColor: "white",
                color: "#26365C",
                boxShadow: "0 1px 3px rgba(0,0,0,0.4)",
              }}
            />
          </div>
        )}
      </Header>

      {/* MOBILE DRAWER */}
      <Drawer
        title="Menu"
        placement="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={260}
        headerStyle={{
          background: "#FFD700",
          color: "#26365C",
          fontWeight: "bold",
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          selectedKeys={[location.pathname]}
          items={mobileMenuItems}
          mode="inline"
          className="gold-menu"
          onClick={() => setDrawerOpen(false)}
        />
      </Drawer>
    </>
  );
};

export default AppHeader;